import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useForm from '@components/form/hooks/useForm';

import { updateUser } from '@actions/users';
import { getUserIsPosting, getUserPostSuccess, getUsersError } from '@selectors/users';
import { User } from 'src/types/shared/User';

export default function useUpdateUser({
    id,
    email,
    firstName,
    lastName,
}: User): UseUpdateUserReturn {
    const dispatch = useDispatch();

    const [formState, handleChange] = useForm({ email, firstName, lastName });

    const handleSubmit = useCallback(() => {
        dispatch(updateUser(id, formState));
    }, [dispatch, id, formState]);

    const isPosting = useSelector(getUserIsPosting);
    const error = useSelector(getUsersError);
    const postSuccess = useSelector(getUserPostSuccess);

    return {
        handleSubmit,
        formState,
        handleChange,
        isPosting,
        error,
        postSuccess,
    };
}

interface FormState {
    email: string;
    firstName: string;
    lastName: string;
}

interface UseUpdateUserReturn {
    handleSubmit: () => void;
    formState: FormState;
    handleChange: <T>(name: 'firstName' | 'lastName' | 'email', value: T) => void;
    isPosting: boolean;
    error: string | null;
    postSuccess: boolean;
}
